
// import { useEffect } from "react";

// function MOUProcess() {
//   useEffect(() => {
//     window.location.href = "/Mark/MouOrderForm";
//   }, []);

//   return null;
// }

// export default MOUProcess;

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

 export default function MOUProcess(){
  const navigate = useNavigate();

  useEffect(()=>{
    navigate("/MouOrderForm");
  },[navigate]);

  return null;
 } 
